import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { IUserDetailsEntity } from '../../../entity';

export interface ILoginWithCredentialsUseCase {
    execute(
        username: string,
        password: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string | null
    ): Promise<IUserDetailsEntity>;
}

export class LoginWithCredentialsUseCase implements ILoginWithCredentialsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        password: string,
        apiToken: { [key: string]: string },
        recaptchaToken: string
    ): Promise<IUserDetailsEntity> {
        const response = await this.authRepo.loginWithCredentials(username, password, apiToken, recaptchaToken);
        return response.data as IUserDetailsEntity;
    }
}
